import { useQuery } from 'react-query';
import { useService } from 'shared/providers';

export function useQueryCustomerChannels() {
  const { customerService } = useService();
  const { data, isLoading, isFetching } = useQuery<string[], Error>('customer-channels', () =>
    customerService.getCustomerChannels()
  );

  return { channelOptions: data, isLoading, isFetching } as const;
}
